import type { Country } from '@/components/BrandProfile/CountrySelector'
import PhoneInputWithCountry from '@/components/BrandProfile/PhoneInputWithCountry'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import { Select } from '@/components/ui/Select'
import type { ChangeEvent } from 'react'
import styles from './registration.module.css'

interface RegistrationYourProfileFormProps {
  values: {
    firstName: string
    lastName: string
    phoneNumber: string
    region: string
    selectedCountry: string
  }
  // errors: Record<string, string>
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void
  onPhoneChange: (value: string) => void
  onCountryChange: (country: Country) => void
  onRegionChange: (value: string) => void
  onNext: () => void
  onBack: () => void
  nextDisabled?: boolean
  regionOptions: { value: string; label: string }[]
}

const RegistrationYourProfileForm = ({
  values,
  // errors,
  onChange,
  onPhoneChange,
  onCountryChange,
  onRegionChange,
  onNext,
  onBack,
  regionOptions,
  nextDisabled,
}: RegistrationYourProfileFormProps) => {
  return (
    <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
      <Input id="firstName" placeholder="Name" value={values.firstName} onChange={onChange} minLength={1} maxLength={50} />

      <Input id="lastName" placeholder="Surname" value={values.lastName} onChange={onChange} minLength={1} maxLength={50} />

      <div className={styles.phoneWrapper}>
        <PhoneInputWithCountry
          id="phoneNumber"
          label=""
          placeholder="Phone Number"
          phoneValue={values.phoneNumber}
          selectedCountry={values.selectedCountry}
          // error={errors.phoneNumber}
          onChange={onPhoneChange}
          onCountryChange={onCountryChange}
        />
      </div>

      <Select id="region" placeholder="Region" options={regionOptions} value={values.region} onChange={onRegionChange} />

      <div className={styles.buttonGroup}>
        <Button type="button" variant="outline" size="large" style={{ width: '100%' }} className={styles.backBtn} onClick={onBack}>
          Back
        </Button>
        <Button
          type="button"
          variant="fill"
          size="large"
          style={{ width: '100%' }}
          className={styles.submitBtn}
          onClick={onNext}
          disabled={!!nextDisabled}
        >
          Next
        </Button>
      </div>
    </form>
  )
}

export default RegistrationYourProfileForm
